import kaiFontAsset from "../assets/fonts/moe-standard-kai/edukai.ttf";

// CRA's relative homepage emits ./static/media URLs. Font requests must not
// resolve relative to the current SPA route. Importing also puts the font in
// static/media, which Django's collectstatic includes in production.
export const handoutFontAssetUrl = (url) => url.replace(/^\.\//, "/");
export const handoutKaiFontUrl = handoutFontAssetUrl(kaiFontAsset);
export const handoutKaiFontFamily = '"HandoutKai", "標楷體", "DFKai-SB", "BiauKaiTC", "BiauKai", "Kaiti TC", "KaiTi", serif';
export const handoutKaiLocalSources = 'local("DFKai-SB"), local("DFKaiShu-SB-Estd-BF"), local("標楷體")';
